<template>
  <v-card :height="editorHeight" class="elevation-0">
    <v-card-text class="ml-0">
      <div ref="jsonView" class="vop--ace-editor"></div>
    </v-card-text>
  </v-card>
</template>

<script>
import ace from "brace"
import "brace/mode/json"
import "brace/theme/eclipse"
import "brace/ext/searchbox"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import messages from "@/MetadataRules/messages.json"

export default {
  name: "JSONView",
  props: ["json"],
  computed: {
    editorHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "60vh"
        case "sm":
          return "60vh"
        case "md":
          return "68vh"
        case "lg":
          return "68vh"
        case "xl":
          return "80vh"
      }
    },
    jsonString() {
      // parse 'actions' or 'conditions' if exits ( applicable if it's a rule object )
      this.json = this.parseConditionsAndActions(this.json)
      // Parse 'rules' ( applicable for ruleSet)
      if (!this.$lodash.isUndefined(this.json.rules)) {
        this.$lodash.forEach(this.json.rules, (rule, index) => {
          this.json.rules[index] = this.parseConditionsAndActions(rule)
        })
      }
      // Parse 'ruleSetDetails' ( applicable for rulecollection)
      if (!this.$lodash.isUndefined(this.json.ruleSetDetails)) {
        this.$lodash.forEach(
          this.json.ruleSetDetails,
          (ruleSet, ruleSetIndex) => {
            this.$lodash.forEach(ruleSet.rules, (rule, ruleIndex) => {
              let ruleSetDetails = this.json.ruleSetDetails[ruleSetIndex]
              ruleSetDetails.rules[ruleIndex] = this.parseConditionsAndActions(
                rule
              )
            })
          }
        )
      }
      return JSON.stringify(this.json, null, "\t")
    }
  },
  watch: {
    json: {
      handler: function () {
        this.showJSON(this.jsonString)
      },
      deep: true
    }
  },
  data() {
    return {}
  },
  methods: {
    /**
     * openXMLEditor - Open XML Editor
     * @param {string} jsonString
     */
    showJSON(jsonString) {
      let editor
      editor = ace.edit(this.$refs.jsonView)
      editor.setReadOnly(true)
      this.$refs.jsonView.style.backgroundColor = "floralwhite"
      editor.setTheme("ace/theme/eclipse")
      editor.getSession().setMode("ace/mode/json")
      editor.session.setValue(jsonString)
      this.$nextTick(() => {
        editor.resize(true)
      })
    },
    /**
     * parseConditionsAndActions
     * @param {object} jsonObj
     * @returns {object}
     */
    parseConditionsAndActions(jsonObj) {
      if (!this.$lodash.isUndefined(jsonObj.conditions)) {
        jsonObj.conditions = MetadataRulesService.parseArrayOfStrings(
          jsonObj.conditions,
          false
        )
      }
      if (!this.$lodash.isUndefined(jsonObj.actions)) {
        jsonObj.actions = MetadataRulesService.parseArrayOfStrings(
          jsonObj.actions,
          false
        )
      }

      return jsonObj
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
  },
  updated() { }
}
</script>
<style lang="scss" scoped>
.vop--ace-editor {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/JSONView.vue